<template>
  <div class="h-screen flex flex-col overflow-hidden">
    <header class="flex flex-wrap items-center gap-x-4 gap-y-2 px-4 md:px-6 py-3 border-b border-line shrink-0">
      <div class="flex items-baseline gap-3">
        <h1 class="font-display text-2xl font-semibold tracking-tight text-ink">
          Ampelos<span class="text-wine-bright">.</span>
        </h1>
        <span class="text-[0.7rem] uppercase tracking-[0.2em] text-ink-faint hidden lg:inline">the wine world, mapped</span>
      </div>

      <div class="ml-auto flex items-center gap-2 md:gap-3 order-2 md:order-3">
        <GrapeSearch />
        <button @click="store.chatOpen = !store.chatOpen" title="Ask the sommelier"
          class="px-3.5 py-1.5 rounded-full text-sm border transition-colors shrink-0"
          :class="store.chatOpen ? 'border-gold/60 text-gold-bright bg-gold/10' : 'border-line text-ink-dim hover:text-ink'">
          ✦<span class="hidden md:inline"> Ask the sommelier</span>
        </button>
      </div>

      <nav class="flex gap-1 md:ml-4 order-3 md:order-2 w-full md:w-auto overflow-x-auto pb-1 md:pb-0">
        <button v-for="t in tabs" :key="t.id" @click="exploreView(t.id)"
          class="px-3.5 py-1.5 rounded-full text-sm transition-colors whitespace-nowrap shrink-0"
          :class="store.view === t.id
            ? 'bg-wine/25 text-ink border border-wine/50'
            : 'text-ink-dim hover:text-ink border border-transparent'">
          {{ t.label }}
        </button>
      </nav>
    </header>

    <div class="flex flex-1 min-h-0">
      <main class="flex-1 min-w-0 relative">
        <div v-if="!store.loaded" class="h-full grid place-items-center text-ink-dim font-display text-xl italic">
          decanting the data…
        </div>
        <template v-else>
          <NetworkView v-if="store.view === 'network'" />
          <LineageView v-else-if="store.view === 'lineage'" />
          <CompoundsView v-else-if="store.view === 'compounds'" />
          <WheelView v-else-if="store.view === 'wheel'" />
          <WineView v-else-if="store.view === 'wine'" />
          <LayersView v-else-if="store.view === 'layers'" />
        </template>
      </main>

      <GrapeDetail v-if="selectedGrape" :grape="selectedGrape" class="shrink-0" />
      <ChatPanel v-if="store.chatOpen" class="shrink-0" />
    </div>

    <footer class="shrink-0 border-t border-line px-4 py-1.5 flex items-center justify-end gap-1.5 text-[0.65rem] tracking-wide text-ink-faint">
      made by
      <a href="https://agentaconsulting.com" target="_blank" rel="noopener"
        class="opacity-70 hover:opacity-100 transition-opacity">
        <img :src="'/agenta-wordmark.svg'" alt="Agenta" class="h-3" />
      </a>
    </footer>
  </div>
</template>

<script setup>
import { onMounted } from "vue"
import { store, loadAll, selectedGrape, exploreView } from "./store"
import NetworkView from "./components/NetworkView.vue"
import LineageView from "./components/LineageView.vue"
import CompoundsView from "./components/CompoundsView.vue"
import WheelView from "./components/WheelView.vue"
import WineView from "./components/WineView.vue"
import LayersView from "./components/LayersView.vue"
import GrapeDetail from "./components/GrapeDetail.vue"
import ChatPanel from "./components/ChatPanel.vue"
import GrapeSearch from "./components/GrapeSearch.vue"

const tabs = [
  { id: "network", label: "Flavour network" },
  { id: "lineage", label: "Lineage" },
  { id: "wheel", label: "Flavour wheel" },
  { id: "compounds", label: "Compounds" },
  { id: "layers", label: "Layers" },
  { id: "wine", label: "Taste a wine" },
]

onMounted(() => {
  const shared = location.pathname.match(/^\/w\/([A-Za-z0-9]+)/)
  if (shared) {
    store.pendingShareId = shared[1]
    store.view = "wine"
  }
  loadAll()
})
</script>
